import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, Kicker, SectionH2, SECTION_PAD, useSectionView } from './shared';

const PAINS = [
  { num: '01', title: 'Deciding takes longer than doing', body: 'You spend more time working out what to market than actually marketing. By the time you decide, the day is gone.' },
  { num: '02', title: 'Every session starts from zero', body: 'You sit down to post and nothing comes out. A blank page, a scroll through Instagram for inspiration, then nothing ships. Again.' },
  { num: '03', title: 'Your marketing lives in six tabs', body: 'Strategy in your head. Research in one tool, copy in another, design in a third, scheduling in a fourth. None of them tells you what to do today.' },
];

export const ProblemSection = () => {
  const ref = useSectionView('problem');
  return (
    <section ref={ref} style={{ padding: SECTION_PAD, background: 'rgba(255,255,255,0.012)' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <FadeUp><Kicker>The problem</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2>
            You&rsquo;re not bad at marketing.<br />
            <span style={{ color: 'rgba(242,245,234,0.45)' }}>You&rsquo;re doing six jobs at once.</span>
          </SectionH2>
        </FadeUp>
        <FadeUp delay={140}>
          <p style={{ marginTop: 18, fontFamily: MONO, fontSize: 12, letterSpacing: '0.14em', color: C.lime, textTransform: 'uppercase' }}>
            Fire the marketing chaos.
          </p>
        </FadeUp>
        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))', gap: 18 }}>
          {PAINS.map((c, i) => (
            <FadeUp key={i} delay={i * 100}>
              <div className="scl-card" style={{ position: 'relative', padding: '32px 26px', border: `1px solid ${C.border}`, borderRadius: 16, background: C.surface, height: '100%', overflow: 'hidden' }}>
                <span aria-hidden="true" style={{ position: 'absolute', top: 18, right: 22, fontFamily: DISP, fontWeight: 800, fontSize: 52, color: 'rgba(200,241,53,0.07)', lineHeight: 1 }}>{c.num}</span>
                <div style={{ width: 22, height: 2, background: C.lime, marginBottom: 22 }} />
                <p style={{ fontFamily: DISP, fontWeight: 700, fontSize: 18, color: C.text, marginBottom: 12 }}>{c.title}</p>
                <p style={{ fontFamily: BODY, fontSize: 14.5, lineHeight: 1.7, color: C.body }}>{c.body}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
